import axios from 'axios'

const { CORPORATE_API_URL } = process.env

const rolesApi = axios.create({
  baseURL: CORPORATE_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default rolesApi
